import React from 'react';
import clsx from 'clsx';
import capitalize from 'lodash/capitalize';
import { withStyles } from 'common/util/react';
import { react2panel } from 'iron/common/util/react2panel';
import { SvgIconReact } from '../svg-icon';
import { MarkdownReact } from '../markdown';
import { SvgIconType } from '../svg-icon/types';
import { LENGTH, SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightProps } from './types';
import styles from './index.module.styl';
import css from './index.module.styl?inline';
export function TextHighlight({
  icon,
  textBeforeIcon,
  theme = TEXT_HIGHLIGHT_THEME.NEUTRAL,
  length = LENGTH.THIN,
  size = SIZE.MEDIUM,
  markdown,
  noWrap,
  text,
  className,
  elref,
  onClick,
  style
}: TextHighlightProps): React.ReactNode {
  return <div className={clsx(styles.mpTextHighlight, className, {
    [styles[`${theme}`]]: true,
    [styles[`size${capitalize(size)}`]]: true,
    [styles[`length${capitalize(length)}`]]: true,
    [styles.noWrap]: noWrap
  })} elref={elref || `textHighlight`} onClick={onClick} style={style} data-sentry-component="TextHighlight" data-sentry-source-file="index.tsx">
      {icon && !textBeforeIcon && <SvgIconReact className={styles.icon} icon={icon as SvgIconType} />}
      {text && <div className={`text`}>{text}</div>}
      {markdown && <div className='markdown text'>
          <MarkdownReact text={markdown} />
        </div>}
      {icon && textBeforeIcon && <SvgIconReact icon={icon as SvgIconType} className={`text-before-icon`} />}
    </div>;
}
export const TextHighlightReact = withStyles(TextHighlight, css);
export const TextHighlightEl = react2panel(`mp-text-highlight`, TextHighlightReact);